import React from "react";
import { ChevronDownIcon } from "../Dashboard/icons";
import FontPicker from "./FontPicker";

const messageSizes = ["Small", "Medium", "Large"];
const nameStyles = ["Regular", "Medium", "Bold"];

export default function TypographyCard({ settings, onChange }) {
  return (
    <section className="dash-card cz-card">
      <h2 className="cz-card-title">2. Typography</h2>

      <div className="cz-field-row">
        <div className="cz-field">
          <span className="cz-field-label">Font family</span>
          <FontPicker
            value={settings.fontFamily}
            onChange={(v) => onChange("fontFamily", v)}
          />
        </div>

        <label className="cz-field">
          <span className="cz-field-label">Font size</span>
          <span className="cz-slider-row">
            <input
              type="range"
              min="12"
              max="20"
              value={settings.fontSize}
              onChange={(e) => onChange("fontSize", Number(e.target.value))}
            />
            <span className="cz-slider-value">{settings.fontSize}px</span>
          </span>
        </label>
      </div>

      <div className="cz-field-row">
        <div className="cz-field">
          <span className="cz-field-label">Message size</span>
          <div className="cz-segmented">
            {messageSizes.map((size) => (
              <button
                type="button"
                key={size}
                className={settings.messageSize === size ? "is-active" : ""}
                onClick={() => onChange("messageSize", size)}
              >
                {size}
              </button>
            ))}
          </div>
        </div>

        <label className="cz-field">
          <span className="cz-field-label">Assistant name style</span>
          <span className="cz-select-wrap">
            <select value={settings.nameStyle} onChange={(e) => onChange("nameStyle", e.target.value)}>
              {nameStyles.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
            <ChevronDownIcon />
          </span>
        </label>
      </div>
    </section>
  );
}
